import api from './api';

export const contactService = {
  getContacts: async () => {
    console.log('📥 Getting contacts...');
    try {
      const response = await api.get('/contacts');
      console.log('📥 Contacts response:', response);
      console.log('📥 Contacts data:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Error getting contacts:', error);
      throw error;
    }
  },
  updateContacts: (data) => {
    console.log('📤 Updating contacts with data:', data);
    console.log('📤 Data type:', typeof data);
    console.log('📤 Data stringified:', JSON.stringify(data));
    console.log('🔑 Token presente:', localStorage.getItem('token') ? 'Sim' : 'Não');
    
    // Verificar se os dados estão no formato correto
    const requiredFields = ['instagram', 'facebook', 'whatsapp', 'email'];
    const missingFields = requiredFields.filter(field => !(field in data));
    if (missingFields.length > 0) {
      console.error('❌ Campos obrigatórios ausentes:', missingFields);
    }
    
    return api.put('/contacts', data);
  },
};
